import { connect } from 'react-redux';
import SetPasswordPage from 'pages/SetPasswordPageNew';
import Actions from 'store/auth/actions';

const mapStateToProps = state => {
  return {
    isSettingPassword: state.auth.isSettingPassword,
    setPasswordData: state.auth.setPasswordData,
  };
};

const mapDispatchToProps = {
  changePassword: Actions.Creators.changePasswordRequest,
  resetPasswordData: Actions.Creators.resetPasswordData,
};

export default connect(mapStateToProps, mapDispatchToProps)(SetPasswordPage);
